import React, { FunctionComponent, ReactNode } from 'react';
import { Helmet } from 'react-helmet';
import { isEmpty, isNil } from 'ramda';
import { Tag } from '../types';
import { getTranslatedMetaTags, getAttributes } from '../utils';

interface Props {
  data: Array<Tag>;
  translate?(key: string): string;
  format?(html: string): string;
}

export const MetaTagsList: FunctionComponent<Props> = ({ data, translate = key => key, format = html => html }) => {
  return isNil(data) || isEmpty(data) ? null : (
    <Helmet>
      {getTranslatedMetaTags(data, translate).map(
        (tag: Tag): ReactNode => {
          const Component = tag.tagName;
          // @ts-ignore
          return <Component key={tag.id} children={format(tag.tagContent)} {...getAttributes(tag)} />;
        }
      )}
    </Helmet>
  );
};
